import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-lively',
  templateUrl: './lively.component.html',
  styleUrls: ['./lively.component.scss']
})
export class LivelyComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['lively'];
  }

}
